import SpriteSymbol from "../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "plug-icon",
  "use": "plug-icon-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"plug-icon\"><path d=\"M2.908 5.137c0 .316.257.572.573.572h.559v2.864c0 1.263 1.014 2.29 2.262 2.29h1.131v2.299a.566.566 0 1 0 1.132 0v-2.298h1.131c1.248 0 2.263-1.028 2.263-2.291V5.709h.558a.573.573 0 0 0 0-1.145H3.481a.573.573 0 0 0-.573.573Zm2.263-2.298a.566.566 0 1 1 1.131 0V3.99H5.171V2.84Zm4.525 0a.566.566 0 1 1 1.131 0V3.99h-1.13V2.84Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol